import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../style.scss";
import { useSelector, useDispatch } from "react-redux";
import { logoutRequest } from "../redux/reducer/AuthReducer";
import { Nav } from "react-bootstrap";
import { useTheme } from "../provider/ThemeProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

function Header(props) {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [user, setUser] = useState({});
  const dropdownRef = useRef(null);
  const location = useLocation();
  const loginResponse = useSelector(
    (state) => state?.AuthReducer?.loginResponse
  );
  const dispatch = useDispatch();

  // load saved user from localStorage (for fallback display)
  useEffect(() => {
    const savedUser = JSON.parse(localStorage.getItem("user"));
    if (savedUser) setUser(savedUser);
  }, []);

  const getInitial = () => {
    if (loginResponse?.data?.name)
      return loginResponse?.data?.name.charAt(0).toUpperCase();
    if (user?.email) return user.email.charAt(0).toUpperCase();
    return "?";
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    const token = localStorage.getItem("access_token");
    const user_id =
      loginResponse?.data?.user_id || localStorage.getItem("user_id");

    dispatch(
      logoutRequest({
        token,
        user_id,
        onSuccess: () => {
          console.log("Logout successful, redirecting…");
          localStorage.clear();
          window.location.href = "/";
        },
      })
    );
  };

  const handleLogoClick = () => {
    navigate("/dashboard");
  };

  return (
    <header className="site-header">
      <div className="header-left d-flex align-items-center">
        {location.pathname !== "/dashboard" && (
          <button
            className="back-btn me-3"
            onClick={() => navigate(-1)}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
            }}
          >
            <FontAwesomeIcon icon={faArrowLeft} size="lg" />
          </button>
        )}

        <div
          className="logo"
          onClick={handleLogoClick}
          style={{ cursor: "pointer" }}
        >
          <img
            src="https://www.dotandkey.com/cdn/shop/files/Vector_5.svg?v=1720438003&width=450"
            alt="Logo"
          />
        </div>
      </div>

      {!props.hideUserTab && (
        <div className="user" ref={dropdownRef}>
          <div onClick={() => setDropdownOpen(!dropdownOpen)} className="ini">
            {getInitial()}
          </div>

          {dropdownOpen && (
            <div className="dropdown">
              <div className="mb-2">
                <Nav.Link as={Link} to="/profile">
                  <strong>{loginResponse?.data?.name || user?.email}</strong>
                </Nav.Link>
              </div>
              {loginResponse?.data?.name === "" ||
              !loginResponse?.data?.name ? (
                <button
                  className="btn btn-sm btn-outline-primary w-100 mb-2"
                  onClick={() => navigate("/profile")}
                >
                  Set Name
                </button>
              ) : null}
              <button
                className="btn btn-sm btn-danger w-100"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      )}
    </header>
  );
}

export default Header;
